import { ratedDisabilities } from './ratedDisabilities';
import { totalRating } from './totalDisabilities';

const rootReducer = {
  ratedDisabilities,
  totalRating,
};

export default rootReducer;
